export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13830.6895fb2c.jpg";